module.exports = __webpack_public_path__ + "img/list-pattern1.8e2839f.svg";